import React from 'react';
import { Facebook, Instagram, Youtube, Mail } from 'lucide-react';

export default function StickySocial() {
  return (
    <div className="sticky-social">
      <a href="https://web.facebook.com/thespinsafe" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
        <span className="label">Folge uns auf<br />Facebook</span>
        <Facebook size={22} />
      </a>
      <a href="https://instagram.com/thespinsafe" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
        <span className="label">Folge uns auf<br />Instagram</span>
        <Instagram size={22} />
      </a>
      <a href="https://youtube.com/channel/UCwVazbaXwbS-S8AhqT4xGrw" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
        <span className="label">Folge uns auf<br />Youtube</span>
        <Youtube size={22} />
      </a>
      <a href="#contact" aria-label="Newsletter">
        <span className="label">Abonniere unseren<br />Newsletter</span>
        <Mail size={22} />
      </a>
    </div>
  );
}
